import axios from "axios"

// 这个baseUrl要根据实际情况进行改变
axios.defaults.baseURL = "/"
axios.defaults.headers.common["Content-Type"] = "application/json; charset=UTF-8"
//axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*"
axios.defaults.timeout = 30000
import router from '@/router'
import notification from 'ant-design-vue/es/notification'
import store from "@/store"
// 请求拦截器 添加token
axios.interceptors.request.use(
    config => {
        let token = sessionStorage.getItem('Authorization') 
        if (token) {
          config.headers = { 
            Authorization: "Bearer " + token 
          };
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

//响应拦截器即异常处理
axios.interceptors.response.use(
    response => {
        return response
    },
    error => {
        console.error("reject", error)
        return Promise.reject(error)
    }
)

export default {
    // get请求
    get(url, param,param2) {
        if(param2){
          url+='?unitname='+param
        }
        if (url.indexOf("?") > -1) {
            url += "&t=" + new Date().getTime();
        } else {
            url += "?t=" + new Date().getTime();
        }
        return new Promise((resolve, reject) => {
          axios({
              method: "get",
              url,
              params: param,
          })
          .then(res => {
              resolve(res)
          })
          .catch(err => {    
            let error = err.response;
            if(error){
              if (error.status == 401 || error.status == 403) {  
                try{
                  router.push({ name: "Login" }) 
                }catch{}  
                return;
                if (url.indexOf("api/TroopsInfo/GetTroopInfo") > -1) { 
                  router.push({ name: "Login" }).catch(err => {console.error(err)}); 
                  return;
                }
                notification["warning"]({
                  message: '错误信息',
                  description: '用户没有权限',
                });
              } else {
                notification['error']({
                  message: '错误',
                  description: '服务器错误',
                });
              } 
            } 
            reject(err)
          })
        })
    }, 

    // post请求
    post(url, param) {
        if (url.indexOf("?") > -1) {
            url += "&t=" + new Date().getTime();
        } else {
            url += "?t=" + new Date().getTime();
        }
        return new Promise((resolve, reject) => { 
            axios({
                method: "post",
                url,
                data: param 
            })
            .then(res => { 
                resolve(res)
            })
            .catch(error => { 
                console.error(url, error);
                reject(error)
            })
        })
    },
    // all get
    allGet(fnArr) {
        return axios.all(fnArr)
    },

    delete(url, param) {
      if (url.indexOf("?") > -1) {
        url += "&t=" + new Date().getTime();
      } else {
        url += "?t=" + new Date().getTime();
      }
      return new Promise((resolve, reject) => {
        axios({ method: "delete", url, data: param })
        .then(res => { 
          if (res.status == 200 && res.data.status == 1000) { 
            resolve(res.data);
          } else {
            reject(res);
          }
        })
        .catch(err => {
          let error = err.response;
          if (error.status == 401 || error.status == 403) {
            if (url.indexOf("api/User/info") > -1) {
              console.log(router)
              router.push({ name: "Login" }).catch(err => {console.error(err)}); 
              return;
            }
            notification["warning"]({
              message: '错误信息',
              description: '用户没有权限',
            });
          } else {
            notification['error']({
              message: '错误',
              description: '服务器错误',
            });
          } 
        });
      })
    },


    delete2(url, param) {
      if (url.indexOf("?") > -1) {
        url += "&t=" + new Date().getTime();
      } else {
        url += "?t=" + new Date().getTime();
      }
      return new Promise((resolve, reject) => {
        axios({ method: "delete", url, params: param })
        .then(res => { 
          if (res.status == 200 && res.data.status == 1000) { 
            resolve(res.data);
          } else {
            reject(res);
          }
        })
        .catch(err => {
          let error = err.response;
          if (error.status == 401 || error.status == 403) {
            if (url.indexOf("api/User/info") > -1) {
              console.log(router)
              router.push({ name: "Login" }).catch(err => {console.error(err)}); 
              return;
            }
            notification["warning"]({
              message: '错误信息',
              description: '用户没有权限',
            });
          } else {
            notification['error']({
              message: '错误',
              description: '服务器错误',
            });
          } 
        });
      })
    }
}